import { AxiosError } from "axios";

type ApiErrorBody = {
  error?: {
    message?: string | string[];
    tag?: string;
  };
};

export function getAuthErrorKey(
  err: unknown,
  fallback = "auth.login.errors.invalid",
): string {
  const axiosErr = err as AxiosError<ApiErrorBody>;
  const message = axiosErr.response?.data?.error?.message;

  if (typeof message === "string" && message.startsWith("auth.")) {
    return message;
  }

  const tag = axiosErr.response?.data?.error?.tag;
  if (typeof tag === "string" && tag.startsWith("auth.")) {
    return tag;
  }

  return fallback;
}
